import { render, staticRenderFns } from "./DialConfig.vue?vue&type=template&id=4074dec6"
import script from "./DialConfig.vue?vue&type=script&lang=js"
export * from "./DialConfig.vue?vue&type=script&lang=js"
import style0 from "./DialConfig.vue?vue&type=style&index=0&id=4074dec6&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports